var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgListDropdown = function SvgListDropdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 1H1v5h4.5v9H15V3h-2V1ZM2 5V2h10v1H5.5v2H2Zm12 9H6.5V4H14v10ZM8.5 5.5h-1v1h1v-1Zm1 0H13v1H9.5v-1Zm-1 3h-1v1h1v-1Zm1 0H13v1H9.5v-1Zm-1 3h-1v1h1v-1Zm1 0H13v1H9.5v-1Z",
    fill: "#000"
  })));
};
export default SvgListDropdown;